import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=27739860&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&id=27739860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27739860",
  null
  
)

export default component.exports